import React, {useEffect} from "react"
import {withPrefix} from "gatsby"
import styled from "styled-components"
import ReactHtmlParser from "react-html-parser";

import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Text from "@airasia/phoenix-components/components/Text"

var Container =styled.div`
    margin:0 auto;


    @media screen and (max-width: 768px) {
        width: 100%;
        flex-direction: column-reverse;
        display: flex;
        
  }
`
var ContainerImage =styled.div`
    width: 45%;
    display: inline-block;
    vertical-align: middle;
    text-align: right;
    margin-bottom:-3px;

    @media screen and (max-width: 768px) {
        width: 95%;
        text-align:center;
  }
`

var ContainerContent =styled.div`
    display: inline-block;
    top:2em;
    
    @media screen and (max-width: 768px) {
      width: 90%;
        padding:15px;
        font-size: 14px;
  }
`
var Content_Desc =styled.p`
    padding: 0px;
    text-align:left;

    @media screen and (max-width: 768px) {
      text-align:center;
    }
`

var BoxContent =styled.div`
   width:100%;
   display:flex;
    
`
var ButtonContent =styled.div`
    color: #ffffff;
    margin-right:2%;
    float: left;
    display:block;
    @media screen and (max-width: 768px) {
  } 
  
`

var Button = styled.div`
padding:5px;
@media screen and (max-width: 768px) {
    width:100%;
    float:left;
  } 

`

export default function RideAppDownload(props) {
    return (
        <Container>
        <ContainerImage>
            <Image
                  placeHolderBackground="none"
                  radius="20px"
                  src={props.images}
                  alt={props.title}
                  width="90%"
                  customProperties={{id: 'mobile-img'}}
                />
            </ContainerImage>
            <ContainerContent>
           {/* <Icon><img src={props.IconContentRight} alt={props.title}/></Icon> */}
           <Title
                accessible
                inverted={false}
                textAlign="left"
                theme="AIRASIA_CLASSIC"
                type="h2"
              >
                {props.title}
              </Title>
            <Content_Desc>
              <Text
                accessible
                display="inlineFlex"
                hasToggle={false}
                opacity={1}
                tag="p"
                textAlign="left"
                theme="AIRASIA_CLASSIC"
                translation={{}}
                type="default"
              >
              {props.description}
              </Text>
            </Content_Desc>

            <BoxContent>
                    <ButtonContent>
                        <Button><a href={props.appstoreURL} target="_blank"><img style={{width:"100%"}} src={props.appstore}/></a></Button>
                    </ButtonContent>
                    <ButtonContent>
                        <Button><a href={props.playstoreURL} target="_blank"><img style={{width:"100%"}} src={props.playstore}/></a></Button>
                    </ButtonContent>
                    </BoxContent>

            </ContainerContent>
        </Container>
    )
}
